import type { T_FalsyValue } from '@enable-tech/shared-types/common/client/types';
import type { I_Brand } from '@enable-tech/shared-types/modules/brand/backend/responses/schemas';
import { E_LoyaltyCardStatus } from '@enable-tech/shared-types/modules/loyaltyProgram/common/backend/enums';

import type { T_AndroidWalletApp } from '@/types/Wallet';

export const getWalletDeepLink = (
  loyaltyCardStatus: E_LoyaltyCardStatus,
  walletPassLink?: string,
) => {
  const walletAppDeepLinks = {
    [E_LoyaltyCardStatus.APPLE_WALLET]: 'wallet://',
    [E_LoyaltyCardStatus.WALLET_PASSES]:
      'intent://#Intent;package=io.walletpasses.android;launchFlags=0x10000000;end',
    [E_LoyaltyCardStatus.GOOGLE_WALLET]:
      'intent://wallet/#Intent;scheme=https;package=com.google.android.apps.walletnfcrel;launchFlags=0x10000000;end',
    [E_LoyaltyCardStatus.ENABLE_WALLET]: walletPassLink,
    [E_LoyaltyCardStatus.UNKNOWN]: undefined,
    [E_LoyaltyCardStatus.REMOVED]: undefined,
    [E_LoyaltyCardStatus.NOT_ADDED]: undefined,
  };

  return loyaltyCardStatus ? walletAppDeepLinks[loyaltyCardStatus] : undefined;
};

export const isWalletAppEnabled = (brand: T_FalsyValue<I_Brand>, walletApp: T_AndroidWalletApp) =>
  Boolean(brand?.loyaltyProgramConfig?.androidWalletApps?.includes(walletApp));

export const isWalletAppConfigurationMissing = (brand: T_FalsyValue<I_Brand>) =>
  !brand?.loyaltyProgramConfig?.androidWalletApps;
